export default "__VITE_ASSET__B6gGUc9M__"